export default __webpack_public_path__ + "static/media/dismantling.95703e9a.svg";